import Cookies from 'js-cookie'

export function getCookie(name: string): string | null {
  const value = Cookies.get(name)
  return value !== undefined ? value : null
}

export function setCookie(name: string, value: string, days?: number) {
  Cookies.set(name, value, days ? { expires: days } : undefined)
}
